import React from 'react';
import PropTypes from 'prop-types';
import {
  findSiteMap,
  siteMapPropType,
} from '@bingads-webui-react/with-site-map';
import { QueryParam } from '@bingads-webui-react/scope-service';

export const ACCOUNT_MODE = {
  DEFAULT: null,
  EXPERT: 0,
  SMART: 1,
  UNIFIED_SMART: 2,
  UNIFIED_EXPERT: 3,
};

export class SmartLastURL extends React.PureComponent {
  constructor(props) {
    super(props);
    const { CurrentAccount } = props.serverContext || {};
    this.state = {
      lastUrl: this.formatUrl('', props.scope, false, CurrentAccount && CurrentAccount.AccountMode),
      lastPath: null,
    };
    this.updateLastUrl();
  }

  leafCondition = item => item.children.length === 0 && item.selected === true;

  formatUrl = (url, scope, backToSmartCampaign = false, accountMode) => {
    if (backToSmartCampaign && scope.values.aid) { // back to smart campaign
      return `/campaign/smart?uid=${scope.values.uid}&cid=${scope.values.cid}&aid=${scope.values.aid}`;
    }

    if (accountMode === ACCOUNT_MODE.UNIFIED_SMART && scope.values.aid) {
      return `/campaign/mca?uid=${scope.values.uid}&cid=${scope.values.cid}&aid=${scope.values.aid}`;
    }
    // when we have aid, we can fallback to campaign pages and it will go to default landing apge.
    if (scope.values.aid) {
      return `/campaign/vnext/${url}?uid=${scope.values.uid}&cid=${scope.values.cid}&aid=${scope.values.aid}`;
    } else if (url === '') { // If no aid or url (means user directely landed here) we go to account summary pages.
      return `/campaign/vnext/accounts?uid=${scope.values.uid}&cid=${scope.values.cid}`;
    }
    return `/campaign/vnext/${url}?uid=${scope.values.uid}&cid=${scope.values.cid}`; // the last url the user visited, works for both campaign and accounts
  }

  updateLastUrl = () => {
    const {
      siteMap, scope, serverContext,
    } = this.props;
    const { CurrentAccount } = serverContext;
    if (CurrentAccount && CurrentAccount.AccountMode === ACCOUNT_MODE.SMART) {
      this.setState({
        lastUrl: this.formatUrl('', scope, true),
      });
    } else {
      const selectedChildItem = findSiteMap(siteMap, this.leafCondition);
      if (selectedChildItem) {
        this.setState({
          lastUrl: this.formatUrl(selectedChildItem.route, scope, false, CurrentAccount && CurrentAccount.AccountMode),
          lastPath: selectedChildItem,
        });
      }
    }
  }

  render() {
    this.updateLastUrl();
    return (
      <React.Fragment>
        {this.props.render(this.state)}
      </React.Fragment>
    );
  }
}

SmartLastURL.propTypes = {
  siteMap: siteMapPropType.isRequired,
  render: PropTypes.func.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  serverContext: PropTypes.shape({
  }).isRequired,
};
